import { signCallback } from "./utils";

export const asrConfig = {
  secretId: "AKIDxmLkvslPr67zePOGtISYO0TnsiEYdz9u",
  secretKey: "f7JGySlphJhpgKlyzmOp6Ayb5LRJxNZV",
  appId: 1321109264,
};

export const ivhConfig = {
  virtualmanKey: "7db90ea347ef46e09c82ebe6d6ebb02d",
  sign: "2VROqstXdCwH56+kujFMY0ObWbu+kre0YPh4k5WQqufmEXvDyqskt2JWGbGMDANA4BKC67bjQQPYZLeIL/jeX9TNJWBmRLLGjlEMbeSUHYPCRFINaxP0c0ghKPILqRkMbgrayf6SchGx0gYyzAPuiQ==",
};

export const asrParams = {
  signCallback: signCallback,
  secretid: asrConfig.secretId,
  secretkey: asrConfig.secretKey,
  appid: asrConfig.appId,
  engine_model_type: "16k_zh",
  voice_format: 1,
  hotword_id: "43c25765588711ef8484525400aec391", // 热词key
  customization_id: "", // 自学习模型key
  needvad: 1,
  filter_dirty: 1,
  filter_modal: 2,
  filter_punc: 0,
  convert_num_mode: 1,
  word_info: 2,
};

export const aiDigitalTypeChangeitems = [
  {
    label: "政务大厅",
    value: "政务大厅",
  },
  {
    label: "机场",
    value: "机场",
  },

  {
    label: "医院",
    value: "医院",
  },
  {
    label: "银行",
    value: "银行",
  },
  {
    label: "景区",
    value: "景区",
  },
  {
    label: "营业厅",
    value: "营业厅",
  },
  {
    label: "公司大厅",
    value: "公司大厅",
  },
  {
    label: "...",
    value: "...",
  },
];

export const DigitalTypeConfig = {
  政务大厅: {
    videoApi: "https://hmvideo.heimatianqi.com",
    api: "https://hmszr.heimatianqi.com",
    key: "Bearer app-6c3ppvSELyBEwXX7DMIJx8VB",
    defaultMessage: "您好！我是四川企业之家服务管家小智",
  },
};

export const defaultMessage = [
  {
    type: "receive",
    text: "您好！我是四川企业之家服务管家小智",
  },
];

// 配置模块是否启用
export const moduleConfig = {
  modeChange: false, // 模式切换
  logo: false, // logo
  greet: false, // 打招呼
};

export const closeWordList = [
  "再见",
  "拜拜",
  "再见了",
  "再见吧",
  "拜拜了",
  "告辞",
  "不需要你了",
  "退下",
  "bye",
  "goodbye",
  "关闭吧",
  "关闭问答",
];

export const startWord =
  /小启(?:小启)?|消气|小齐|小琪|小骑|小七|小起(?:小起)?/g;
